import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const getters = {
  GETTER_SB_WORKGROUPS: state => state.sbWorkgroups
};

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/shiftboard/getters.js